// Firebase configuration will be created in the plugin
export function getFirebaseConfig() {
  const config = useRuntimeConfig()
  
  return {
    apiKey: config.public.FIREBASE_API_KEY,
    authDomain: config.public.FIREBASE_AUTH_DOMAIN,
    databaseURL: config.public.FIREBASE_DATABASE_URL,
    projectId: config.public.FIREBASE_PROJECT_ID,
    storageBucket: config.public.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: config.public.FIREBASE_MESSAGING_SENDER_ID,
    appId: config.public.FIREBASE_APP_ID,
  }
}

// Validate that all required Firebase config values are present
export function validateFirebaseConfig(firebaseConfig: any) {
  const requiredKeys = [
    'apiKey',
    'authDomain',
    'projectId',
    'appId',
  ]

  const missingKeys = requiredKeys.filter(key => !firebaseConfig[key] || firebaseConfig[key] === '')

  if (missingKeys.length > 0) {
    throw new Error(`Missing required Firebase configuration: ${missingKeys.join(', ')}`)
  }

  return true
}
